// extracted by mini-css-extract-plugin
export default {"wordSequence":"WordSequence_wordSequence__pWK7W","sequenceWord":"WordSequence_sequenceWord__xiQNG"};